<span
  [class.cursor-pointer]="!disabled()"
  [class.cursor-not-allowed]="disabled()"
  [matMenuTriggerFor]="disabled() ? undefined : menu"
>
  <pr-status-indicator-display
    [backgroundColour]="selectedBackgroundColour()"
    [colour]="selectedColour()"
    [mode]="selectedMode()"
    [character]="selectedCharacter()"
    [icon]="selectedIcon()"
  />
</span>

<mat-menu #menu="matMenu" (closed)="save()">
  <div
    class="flex min-h-[700px] flex-col gap-4 overflow-y-auto p-4 pt-0"
    (click)="$event.stopPropagation()"
  >
    <mat-tab-group
      class="status-indicator-tabs"
      [selectedIndex]="selectedTabIndex()"
      (selectedIndexChange)="updateMode($event)"
    >
      <mat-tab label="Character">
        <div class="flex flex-row items-center gap-2 pt-4">
          <mat-form-field subscriptSizing="dynamic" class="w-full">
            <mat-label>Enter a character</mat-label>
            <input
              matInput
              type="text"
              placeholder="Enter a character"
              [value]="selectedCharacter() ?? ''"
              (input)="characterChange($event)"
            />
          </mat-form-field>
          <pr-status-indicator-display
            [backgroundColour]="selectedBackgroundColour()"
            [colour]="selectedColour()"
            [mode]="selectedMode()"
            [character]="selectedCharacter()"
            [icon]="selectedIcon()"
          />
        </div>
      </mat-tab>

      <mat-tab label="Icons">
        <div class="flex flex-col gap-4 pt-2">
          <pt-icon-picker
            maxHeight="100px"
            [icons]="icons"
            [selectedIcon]="selectedIcon()"
            (iconChange)="iconSelect($event)"
          />

          <div class="flex flex-col">
            <p class="text-sm font-medium">Preview</p>
            <pr-status-indicator-display
              [backgroundColour]="selectedBackgroundColour()"
              [colour]="selectedColour()"
              [mode]="selectedMode()"
              [character]="selectedCharacter()"
              [icon]="selectedIcon()"
            />
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>

    <!-- Character Color picker -->
    <span class="text-sm font-medium">Colour</span>
    <pt-colour-selector
      [colour]="selectedColour()"
      [palette]="characterColourPalette"
      [disableOpacity]="disableOpacity()"
      [enableCustomInput]="true"
      [displayPreviewColour]="false"
      [displayCompactPreviewColour]="true"
      (colourChange)="colourChange($event)"
    />

    <!-- Background Color picker -->
    <span class="text-sm font-medium">Background Colour</span>
    <pt-colour-selector
      [colour]="selectedBackgroundColour()"
      [palette]="palette()"
      [enableCustomInput]="true"
      [displayPreviewColour]="false"
      [displayCompactPreviewColour]="true"
      (colourChange)="backgroundColourChange($event)"
    />
  </div>
</mat-menu>
